import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getHorariosEntregaMostrarTodo,
  cargarRangoHorarioEntrega,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_HORARIOS_MOSTRAR_TODO(action) {
  try {
    const horariosEntrega = yield call(getHorariosEntregaMostrarTodo, action.payload)
    if (horariosEntrega.ok) {
      yield put({
        type: actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_SUCCEEDED,
        payload: horariosEntrega.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar horarios entrega MRW')
      put({
        type: actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_HORARIOS_BY_UBICACION_ID(action) {
  try {
    const horariosEntrega = yield call(cargarRangoHorarioEntrega, action.payload)
    if (horariosEntrega.ok) {
      yield put({
        type: actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_SUCCEEDED,
        payload: horariosEntrega.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar horarios entrega por ubicación')
      put({
        type: actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.HORARIOS_ENTREGA_MOSTRAR_TODO_LOAD_REQUESTED, GET_HORARIOS_MOSTRAR_TODO),
    takeEvery(
      actions.HORARIOS_ENTREGA_BY_UBICACION_ID_LOAD_REQUESTED,
      GET_HORARIOS_BY_UBICACION_ID,
    ),
  ])
}
